import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';

import { VendorRolesService, OrganizationItem } from 'src/app/services/vendor-roles.service';
import { ManageRolesComponent } from './manage-roles/manage-roles.component';
import { AssignUsersComponent } from './assign-users/assign-users.component';

const ORG_STORAGE_KEY = 'vendorRoles_selectedOrgId';

@Component({
  standalone: true,
  selector: 'app-vendor-roles',
  templateUrl: './vendor-roles.component.html',
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
    ManageRolesComponent,
    AssignUsersComponent,
  ],
})
export class VendorRolesComponent implements OnInit {
  @ViewChild(AssignUsersComponent) private assignUsersRef?: AssignUsersComponent;

  organizations: OrganizationItem[] = [];
  selectedOrgId: number | null = null;

  constructor(private vendorRolesService: VendorRolesService) {}

  ngOnInit(): void {
    this.loadOrganizations();
  }

  loadOrganizations(): void {
    this.vendorRolesService.getOrganizations().subscribe({
      next: (orgs) => {
        this.organizations = orgs;
        if (orgs.length === 1) {
          this.selectedOrgId = orgs[0].id;
        } else {
          const stored = localStorage.getItem(ORG_STORAGE_KEY);
          if (stored) {
            const storedId = Number(stored);
            if (orgs.some((o) => o.id === storedId)) {
              this.selectedOrgId = storedId;
            }
          }
        }
      },
    });
  }

  onOrgChange(): void {
    if (this.selectedOrgId !== null) {
      localStorage.setItem(ORG_STORAGE_KEY, String(this.selectedOrgId));
    } else {
      localStorage.removeItem(ORG_STORAGE_KEY);
    }
  }

  onRolesChanged(): void {
    this.assignUsersRef?.reload();
  }
}
